import { z } from 'zod'
import { Model } from './architecture'

export const FullNameValidation = z.object({
  value: z.string({ required_error: '[FullName] value is required' }),
})

export class FullName extends Model {
  static create({ value }: z.infer<typeof FullNameValidation>) {
    FullNameValidation.parse({ value })
    return new FullName(value)
  }

  constructor(private readonly _value: string) {
    super()
  }

  get value() { return this._value } // prettier-ignore

  toJSON() {
    return { value: this.value }
  }
}
